import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './usuarioPerfilForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

import { setModoTela, initForm, salvar, excluir, getLista } from './usuarioPerfilActions';
import { getLista as getListaDepartamento } from '../departamento/departamentoActions';

class UsuarioPerfil extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaDepartamento();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar Interno'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										id_tipo: 1 //Interno
									});
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar Cliente'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										id_tipo: 2 //Cliente
									});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th>Nome</Th>
								<Th alignCenter>Tipo</Th>
								<Th alignCenter>Departamentos</Th>
								<Th alignCenter>Acessos</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.nome} ${item.nome_tipo} ${item.nome_departamentos}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td small>{item.nome}</Td>
									<Td alignCenter small>{item.nome_tipo}</Td>
									<Td alignCenter small>{item.nome_departamentos}</Td>
									<Td alignCenter small>
										{[{
											id: 1,
											nome: 'Dashboard',
											liberado: item.acesso_dashboard
										}, {
											id: 2,
											nome: 'Acessos de Usuários',
											liberado: item.acesso_cadastro_usuario
										}, {
											id: 3,
											nome: 'Departamentos',
											liberado: item.acesso_cadastro_departamento
										}, {
											id: 4,
											nome: 'Cadastros',
											liberado: item.acesso_cadastro_cliente
										}, {
											id: 5,
											nome: 'Configurar Checklists',
											liberado: item.acesso_cadastro_checklist
										}, {
											id: 6,
											nome: 'Modelos de Relatórios',
											liberado: item.acesso_cadastro_modelo_relatorio
										}, {
											id: 7,
											nome: 'Administrar Checklists',
											liberado: item.acesso_checklist_resposta_admin
										}, {
											id: 8,
											nome: 'Responder Checklists',
											liberado: item.acesso_checklist_resposta
										}, {
											id: 9,
											nome: 'Administrar Relatórios',
											liberado: item.acesso_relatorio
										}, {
											id: 9,
											nome: 'Modelos de Certificados',
											liberado: item.acesso_cadastro_modelo_certificado
										}, {
											id: 9,
											nome: 'Emitir Certificados',
											liberado: item.acesso_emitir_certificado
										}].map(acesso => (
											<span key={acesso.id} 
												class={`badge badge-${acesso.liberado ? 'success' : 'secondary'}`}
												style={{
													margin: 2,
													paddingLeft: 8,
													paddingRight: 8,
													fontSize: 12,
													fontWeight: 'normal'
												}}>
												{acesso.nome}
											</span>
										))}
									</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.usuarioPerfil.modoTela,
	lista: state.usuarioPerfil.lista.filter(item => 
		state.auth.usuarioCarregado
		&& (state.auth.usuarioCarregado.id_perfil == 13 //Administrador Geral
			|| item.id != 13)
		&& (item.departamentos || []).filter(departamento => (state.auth.usuarioCarregado.departamentos || []).includes(departamento)).length
	)
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista, getListaDepartamento
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioPerfil);
